import { StandardEvents } from '@shopify/events';

function tierFor(count) {
  if (count >= 4) return 3;
  if (count >= 2) return 2;
  if (count >= 1) return 1;
  return 0;
}

function messageFor(count) {
  if (count >= 4) return 'Buy 3 Get 4th FREE applied — cheapest free';
  if (count >= 2) return '20% OFF applied — add 2 more to get 4th FREE';
  if (count >= 1) return '10% OFF applied — add 1 more for 20% OFF';
  return 'Buy 1 10% OFF • Buy 2 20% OFF • 4th FREE';
}

function widthFor(tier) {
  if (tier === 3) return '100%';
  if (tier === 2) return '55%';
  if (tier === 1) return '25%';
  return '0%';
}

export function updateGeorianOffers(count) {
  const tier = tierFor(count);
  const msg = messageFor(count);
  const width = widthFor(tier);
  document.querySelectorAll('.georian-offer').forEach((el) => {
    el.dataset.tier = String(tier);
    const msgEl = el.querySelector('.georian-offer__msg');
    if (msgEl) msgEl.textContent = msg;
    const fill = el.querySelector('.georian-offer__fill');
    if (fill) fill.style.width = width;
  });
}

export async function refreshGeorianOffers() {
  try {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!res.ok) return;
    const cart = await res.json();
    updateGeorianOffers(cart.item_count || 0);
  } catch (e) {
    /* cart unavailable (preview mode) — keep server-rendered text */
  }
}

if (!window.__georianOfferInit) {
  window.__georianOfferInit = true;
  document.addEventListener(StandardEvents.cartLinesUpdate, refreshGeorianOffers);
  document.addEventListener(StandardEvents.cartError, refreshGeorianOffers);
  document.addEventListener('submit', () => setTimeout(refreshGeorianOffers, 900), true);
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[on\\:click*=\"emove\"], [on\\:click*=\"pdate\"], cart-drawer-component, #cart-drawer');
    if (t) setTimeout(refreshGeorianOffers, 900);
  });
  const drawer = document.getElementById('cart-drawer');
  if (drawer && 'MutationObserver' in window) {
    let pending = false;
    new MutationObserver((muts) => {
      for (const m of muts) {
        if (m.target.closest && m.target.closest('.georian-offer')) continue;
        if (!pending) {
          pending = true;
          setTimeout(() => {
            pending = false;
            refreshGeorianOffers();
          }, 900);
        }
        break;
      }
    }).observe(drawer, { childList: true, subtree: true });
  }
  refreshGeorianOffers();
}
